module.exports = __webpack_public_path__ + "static/media/scene_creator_onboarding_1.7fbfbf46.jpg";